import React from 'react';
import {PageHeader, Select} from 'antd';
import {CollectionWorkProjectType} from '../../hooks/apis/useCollectionWork';
import {SelectProps} from 'antd/lib/select';

type IProps = SelectProps<CollectionWorkProjectType>;
const CollectionWorkProjectTypeSelector = (props: IProps) => {
  return (
    <Select {...props}>
      <Select.Option value={CollectionWorkProjectType.文档}>文档</Select.Option>
      <Select.Option value={CollectionWorkProjectType.图片}>图片</Select.Option>
    </Select>
  );
};
export default CollectionWorkProjectTypeSelector;
